const HalfSpacer = () => {
  return <div className="half-spacer"></div>;
};

export default HalfSpacer;
